import React from "react"
import { Helmet } from "react-helmet"

const TrackingScripts = ({ scripts = [] }) => {
  const elements = []

  scripts?.forEach((snippet, index) => {
    if (!snippet?.code) return

    const scriptMatches = [
      ...snippet.code.matchAll(/<script[^>]*>([\s\S]*?)<\/script>/gi),
    ]
    const noscriptMatches = [
      ...snippet.code.matchAll(/<noscript>([\s\S]*?)<\/noscript>/gi),
    ]

    scriptMatches.forEach((match, i) => {
      if (match[1]) {
        elements.push(
          <script key={`script-${index}-${i}`} type="text/javascript">
            {match[1]}
          </script>
        )
      }
    })

    noscriptMatches.forEach((match, i) => {
      if (match[1]) {
        elements.push(
          <noscript
            key={`noscript-${index}-${i}`}
            dangerouslySetInnerHTML={{ __html: match[1] }}
          />
        )
      }
    })
  })

  return <Helmet>{elements.filter(Boolean)}</Helmet>
}

export default TrackingScripts
